import { DEFAULT_IMAGE } from './siteConfig';

export interface SeoRouteConfig {
  /** Route path used as the lookup key. */
  path: string;
  title: string;
  description: string;
  keywords: string;
  /** Relative path used to build the canonical URL, or null to omit canonical. */
  canonicalPath: string | null;
  image: string;
  robots: string;
  /** Route metadata (authoritative). */
  public: boolean;
  indexable: boolean;
  sitemapInclude: boolean;
  /**
   * When true the runtime head manager keeps the platform / index.html managed
   * values (title, description, keywords, canonical, OG and Twitter tags)
   * instead of overwriting them.
   */
  inheritHead: boolean;
}

/** Home page: existing metadata lives in index.html and is treated as the source of truth. */
export const HOME_SEO: SeoRouteConfig = {
  path: '/',
  title: 'Yakis Transporte Empresarial',
  description:
    'Yakis Transporte Empresarial - Más de 20 años de experiencia en transporte de personal industrial y empresarial en San Luis Potosí y Monterrey. Seguridad, puntualidad y calidad garantizadas.',
  keywords:
    'transporte empresarial, transporte personal, autobuses ejecutivos, San Luis Potosí, Monterrey, flota moderna, movilidad corporativa, viajes, agencia de viajes, turismo',
  canonicalPath: '/',
  image: DEFAULT_IMAGE,
  robots: 'index, follow',
  public: true,
  indexable: true,
  sitemapInclude: true,
  inheritHead: true,
};

/** Catch-all / not found route: not indexable and excluded from the sitemap. */
export const NOT_FOUND_SEO: SeoRouteConfig = {
  path: '*',
  title: 'Página no encontrada | Yakis Transporte Empresarial',
  description:
    'La página que buscas no existe o fue movida. Regresa al inicio para conocer los servicios de transporte empresarial y de personal de Yakis.',
  keywords: '',
  canonicalPath: null,
  image: DEFAULT_IMAGE,
  robots: 'noindex, nofollow',
  public: false,
  indexable: false,
  sitemapInclude: false,
  inheritHead: false,
};

export const seoRoutes: Record<string, SeoRouteConfig> = {
  '/': HOME_SEO,
  '*': NOT_FOUND_SEO,
};

export const getSeoForPath = (pathname: string): SeoRouteConfig =>
  seoRoutes[pathname] ?? seoRoutes['*'];